import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnCH: CultureInfo = {
  name: 'en-CH',
  displayName: 'English (Switzerland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-CH',
  parent: CultureInfoEn
};
